export class FileService {

    fileToDataUrl(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    fileToPlainText(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
            reader.readAsText(file);
        });
    }

    dataUrlToFile(dataUrl, fileName, mimeType) {
        return fetch(dataUrl)
            .then(function (res) {
                return res.arrayBuffer();
            })
            .then(function (buf) {
                return new File([buf], fileName, { type: mimeType });
            })
    }

    isValidImage(file) {
        const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
        return validImageTypes.includes(file.type);
    }

    getFileSizeInMB(file) {
        return file.size / 1024 / 1024;
    }
}
